<template>
  <div>
    <div class="d-none d-md-block">
      <header class="app-header">
      <div class="col-md-8 col-lg-8 col-xl-8">
        <div class="app-search" @click="toggleSearch()"></div>
      </div>
      <div class="col-md-4 col-lg-4 col-xl-4 align-self-center pr-5">
        <div class="float-right d-flex align-items-center">
          <!-- LANGUAGE DROPDOWN -->
          <div class="d-flex">
            <img src="@/assets/img/icons/language-icon.svg" height="25px" width="25px" />
            <b-dropdown
              right
              :text="selectedLanguage"
              variant="transparent text-muted"
              class="lang-btn p-0"
            >
              <div v-for="(language, index) in languages" :key="index">
                <b-dropdown-item @click="changeLanguage(language)">{{ language.title }}</b-dropdown-item>
              </div>
            </b-dropdown>
          </div>

          <!-- NOTIFICATIONS -->
          <!-- <div class="header-notification d-none">
            <button class="btnj btn-notification px-4 mt-1" v-on:click="openNotificaton()"></button>
            <div class="notification-count">150+</div>
            <div class="header-notification-list-container" v-if="showNotification">
              <div class="section-title pb-2 mb-3 border-bottom">Your Notifications</div>

              <ul class="header-notification-list">
                <li v-for="(notificationList , key) in 50" :key="key">
                  <div>
                    <img src="@/assets/img/temp/profile.png" height="45" width="45" alt />
                  </div>

                  <div class="notification-detail">
                    <p class="mb-2">You received a payment of $120.00 from Jhon Smith.</p>
                    <div class="text-muted small">10:00 Am</div>
                  </div>
                </li>
              </ul>
            </div>
          </div>-->

          <!-- PROFILE / SETTINGS -->
          <div class="d-flex ml-2">
            <b-dropdown right variant="transparent">
              <template v-slot:button-content>
                <span style="font-size:14px">{{userInfo}}</span> &nbsp;
                <img width="28" height="28" v-if="imagePath" :src="BASEURL+imagePath" />
                <img v-else src="@/assets/img/icons/user-male.svg" height="28" width="28" />
                <!-- <img v-if="genderId==1 || genderId==null" src="@/assets/img/icons/user-male.svg" height="40" width="40" /> -->
                <!-- <img v-if="genderId==2" src="@/assets/img/icons/user-female.svg" height="40" width="40" /> -->
              </template>

              <!-- <b-dropdown-item href @click.native="goToRoute()">Profile</b-dropdown-item> -->
              <!-- <b-dropdown-item v-b-modal.changePassword>Change Password</b-dropdown-item> -->
              <b-dropdown-item v-on:click="onLogout()" href>Logout</b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </div>
    </header>
    </div>

    <section class="section-global-search" v-if="globalSearch">
      <div class="search-wrapper">
        <div class="search-container">
          <input
            type="search"
            ref="typeBox"
            @keyup="onSearchComponents()"
            placeholder="Search Components, Movies, Distributors"
            v-model="searchText"
            autofocus
          />

          <div class="py-2 border-top border-muted" v-if="searchText.length > 0">
            <ul class="list-unstyled mb-0 px-2 spot-light-search">
              <li
                v-if="ChildNav.hasOwnProperty('permissions') && checkNavPermissions(ChildNav.permissions,ChildNav.cine_direct_sale)"
                v-for="(ChildNav,_index) in SideNav"
                :key="_index"
              >
                <router-link
                  @click.native="toggleSearch()"
                  :to="ChildNav.url"
                >{{ $tc(ChildNav.name, 2) }}</router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="close-backdrop" @click="toggleSearch()"></div>
      </div>
    </section>

    <b-modal
      id="changePassword"
      :size="showcurrentpassword ? 'md' : 'lg' "
      title="Change Password"
      hide-header
      hide-footer
    >
      <form>
        <button
          @click.prevent.stop="OnCloseModal"
          class="btn-modal-close"
          style="position: absolute;right: 15px;top:15px;z-index:99;"
        >&times;</button>
        <div class="row mb-2 mx-0">
          <div class="col-12 text-center mb-4 pb-2 mt-3">
            <h4>Change Password</h4>
          </div>
          <!-- Current / Existing Password -->
          <div class="col-lg- mx-auto align-self-center" v-if="showcurrentpassword">
            <div class>
              <div class="mb-3">
                <div class="input-material">
                  <input
                    type="password"
                    v-model="password"
                    name="currentpass"
                    id="currentpass"
                    v-validate="'required'"
                    placeholder="."
                  />
                  <label>Current Password</label>
                </div>
                <p class="error_message">
                  <span
                    v-if="submitted && errors.has('currentpass')"
                  >{{ errors.first('currentpass') }}</span>
                </p>
              </div>
              <div class="d-flex">
                <button
                  @click="$bvModal.hide('changePassword')"
                  class="btn-white-lg w-50 mr-2"
                >Cancel</button>
                <button
                  @click.prevent.stop="ProceedtoNewPassword"
                  class="btn-blue-lg w-50 ml-2"
                >Proceed</button>
              </div>
            </div>
          </div>

          <!-- New Password -->
          <div class="col-lg-5 border-right" v-if="shownewpassword">
            <ul class="list-unstyled">
              <li class="mb-2">
                <div
                  class="text-muted font-weight-light"
                  style="font-size:16px;"
                >Password must contain:</div>
              </li>
              <li class="mb-3">
                <b-form-checkbox
                  disabled
                  class="j-checkbox"
                  v-model="changePasswordRequirements.atleast6char"
                >
                  <div class="text-muted">Atleaset 6 Character</div>
                </b-form-checkbox>
              </li>
              <li class="mb-3">
                <b-form-checkbox
                  disabled
                  class="j-checkbox"
                  v-model="changePasswordRequirements.atleast1num"
                >
                  <div class="text-muted">Atleaset 1 Number (0-9)</div>
                </b-form-checkbox>
              </li>
              <li class="mb-3">
                <b-form-checkbox
                  disabled
                  class="j-checkbox"
                  v-model="changePasswordRequirements.atleast1uppercase"
                >
                  <div class="text-muted">Atleaset 1 uppercase letter (A-Z)</div>
                </b-form-checkbox>
              </li>
              <li>
                <b-form-checkbox
                  disabled
                  class="j-checkbox"
                  v-model="changePasswordRequirements.atleast1lowercase"
                >
                  <div class="text-muted">Atleaset 1 lowercase letter (a-z)</div>
                </b-form-checkbox>
              </li>
            </ul>
          </div>
          <div class="col-lg-7 pl-5 align-self-center" v-if="shownewpassword">
            <div>
              <div class="mb-3">
                <div class="input-material">
                  <input
                    type="password"
                    v-model="epassword"
                    name="forgotpassword"
                    id="forgotpassword"
                    ref="forgotpassword"
                    v-validate="{required: 'required', regex:/^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,16}$/}"
                    placeholder="."
                    autofocus
                  />
                  <label>Enter Passowrd</label>
                </div>
                <p class="error_msg">
                  <span
                    v-if="submitted && errors.has('forgotpassword')"
                    class="error_message"
                  >{{ errors.first('forgotpassword') }}</span>
                </p>
              </div>
              <div class="mb-3">
                <div class="input-material">
                  <input
                    type="password"
                    v-model="cpassword"
                    name="forgotconfirm"
                    id="forgotconfirm"
                    v-validate="'required|confirmed:forgotpassword'"
                    placeholder="."
                    autofocus
                  />
                  <label>Confirm Passowrd</label>
                </div>
                <p class="error_message">
                  <span
                    v-if="submitted && errors.has('forgotconfirm')"
                    class="error_message"
                  >{{ errors.first('forgotconfirm') }}</span>
                </p>
              </div>
              <div class="d-flex">
                <button
                  @click.prevent.stop="$bvModal.hide('changePassword')"
                  class="btn-white-lg w-50 mr-2"
                >Cancel</button>
                <button @click.prevent.stop="onFinalProceed" class="btn-blue-lg w-50 ml-2">Proceed</button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import languages from "@/helper/Languages";
import i18n from "@/plugins/i18n";
import { BASEURL } from "@/config/index.js";
import UserService from "@/services/UserService";
import Nav from "@/Nav";

export default {
  data() {
    return {
      globalSearch: false,
      searchText: "",
      changePasswordRequirements: {
        atleast6char: true,
        atleast1num: true,
        atleast1uppercase: true,
        atleast1lowercase: true
      },
      showcurrentpassword: true,
      shownewpassword: false,
      password: "",
      epassword: "",
      cpassword: "",
      submitted: false,

      showNotification: false,
      languages,
      selectedLanguage: "English",
      URL_BASE: BASEURL,

      SideNav: [],
      AllSideNav: []
    };
  },
  computed: {
    userInfo() {
      return this.secureStore.get("USINFO") &&
        this.secureStore.get("USINFO").first_name &&
        this.secureStore.get("USINFO").last_name
        ? this.secureStore.get("USINFO").first_name +
            " " +
            this.secureStore.get("USINFO").last_name
        : "Admin";
    },
    userId() {
      return this.secureStore.get("USINFO").user_id;
    },
    genderId() {
      //  console.log("genderr idd ",this.secureStore.get("USINFO").gender_id);
      return this.secureStore.get("USINFO").gender_id;
    },
    imagePath() {
      return this.secureStore.get("USINFO").user_profile_image_url
        ? this.secureStore.get("USINFO").user_profile_image_url
        : null;

      //  console.log("photo pathhh ", this.secureStore.get("USINFO").user_profile_image_url);
      //return this.secureStore.get("USINFO").user_profile_image_url
    }
  },
  mounted() {
    Nav.items.map(x => {
      x.children.map(y => {
        this.SideNav.push(y);
        this.AllSideNav.push(y);
      });
    });
  },
  methods: {
    toggleSearch: function() {
      this.globalSearch = !this.globalSearch;
      this.$nextTick(() => this.$refs.typeBox.focus());
      this.searchText = "";
      // this.$refs.search.focus()
    },
    OnCloseModal() {
      this.$bvModal.hide("changePassword");
      this.shownewpassword = false;
      this.showcurrentpassword = true;
      this.password = "";
    },
    onSearchComponents: function() {
      if (this.searchText.length > 0) {
        this.SideNav = this.AllSideNav.filter(x => {
          if (x.name.toLowerCase().includes(this.searchText.toLowerCase())) {
            return x;
          }
        });
      } else {
        this.SideNav = this.AllSideNav;
      }
    },
    checkNavPermissions: function(permissions, direct_sale_flag) {
      if (!this.secureStore.get("USINFO")) return false;
      else {
        if (direct_sale_flag) {
          const { cine_direct_sale } = this.secureStore.get("USINFO");
          if (cine_direct_sale == "Y") {
            return false;
          }
        }
        const { role_name } = this.secureStore.get("USINFO");
        return permissions && permissions.length > 0
          ? permissions.filter(role => role.trim() === role_name.trim())
              .length > 0
          : true;

      }
    },
    ProceedtoNewPassword() {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          let payload = {
            userid: this.userId,
            userpassword: this.password
          };
          UserService.VerifyCurrentPassword(payload).then(response => {
            console.log("response :", response);
            const { data } = response;

            if (data.status) {
              this.$toasted.show(data.message);
              this.showcurrentpassword = false;
              this.shownewpassword = true;
            } else {
              this.$toasted.show(
                data.message ||
                  "Sorry! Something went wrong. kindly contact your administrator"
              );
            }
          });
        }
      });
    },

    onFinalProceed() {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          // let loader = this.$loading.show();
          let payload = {
            userid: this.userId,
            password: this.cpassword
          };

          UserService.UpdateChangePassword(payload).then(response => {
            console.log("response :", response);
            const { data } = response;

            if (data.status) {
              this.$toasted.show(data.message);
              this.$bvModal.hide("changePassword");
              this.epassword = "";
              this.cpassword = "";
              this.showcurrentpassword = true;
            } else {
              this.$toasted.show(
                data.message ||
                  "Sorry! Something went wrong. kindly contact your administrator"
              );
            }
          });
        }
      });
    },

    goToRoute() {
      this.$router.push({
        path: "/user-management/view-user?user_id=" + this.userId + ""
      });
    },
    openNotificaton: function() {
      this.showNotification = !this.showNotification;
    },
    /* eslint-disable */
    changeLanguage: function({ language, title }) {
      i18n.locale = language;
      this.selectedLanguage = title;
    },
    onLogout: function() {
      UserService.removeToken()
        .then(res => {
          const { data } = res;
          if (data.status == true) {
            window.localStorage.removeItem("JWT_TOKEN");
            window.localStorage.clear();
            this.$router.push({ path: "/login" });
            this.$cookie.delete("BRHSID");
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(err => {
          this.$toasted.show("Token not removed");
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Partials/headerMobile.vue